import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { SportModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { GRID_CONFIG, GridConfig } from '@frontend/sports/grid/core/feature/config';
import { FormGroup } from '@frontend/sports/grid/core/feature/model';

@Component({
    selector: 'ms-form-header',
    template: '<div class="title">{{title}}</div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormHeaderComponent {
    private sitecore = inject(Sitecore);
    private interpolationPipe = inject(StringInterpolationPipe);
    private gridConfig = inject<GridConfig | null>(GRID_CONFIG, { optional: true });

    @Input() form: FormGroup;
    @Input() sport: SportModel;
    @Input() hideFavourites = false;
    @HostBinding('class') className = 'fixture-form-group';

    get title(): string {
        if (this.gridConfig?.hasExtendedOutcome) {
            return this.interpolationPipe.transform(this.sitecore.formCoupon.WonTheirLastMatches, { winCount: `${this.form.winCount}` });
        } else {
            return this.interpolationPipe.transform(this.sitecore.formCoupon.WonTheirLast, { winCount: `${this.form.winCount}/5` });
        }
    }
}
